import { LIGHT_PRODUCT_LIST_FIELDS } from './fragments/productFields';

const getInitialProductsFromCollection = (
    categoryHandle,
    categoryId,
    country
) => `${country ? `query @inContext(country: ${country})` : ''} {
  collection(handle: "${categoryHandle}") {
    handle
    products(first: 24) {
      edges {
        node {
          ${LIGHT_PRODUCT_LIST_FIELDS({
              variantFirst: 5,
              imageCount: categoryHandle === 'all-torsos-new-website' || categoryId === 'bodies' ? 50 : 4,
          })}
        }
        cursor
      }
      pageInfo { hasNextPage }
    }
  }
}`;

export default getInitialProductsFromCollection;
